(function () {
  'use strict';

  /* Scroller for the featured-products slider: mouse drag-to-scroll (the shared
     helper in eb-drag-scroll.js; touch uses native scrolling) and arrow paging
     with an end-state. CSS scroll-snap settles the row after release.
     `is-dragging` is added only once a real drag starts, so a plain click on a
     card's add-to-cart button still fires. */
  class EbFeaturedScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-eb-fp-track]');
      if (!this.track) return;
      this.prevBtn = this.querySelector('[data-eb-fp-prev]');
      this.nextBtn = this.querySelector('[data-eb-fp-next]');

      window.EbDragScroll.attach(this.track);
      this.initArrows();
    }

    initArrows() {
      var self = this;
      if (!this.prevBtn && !this.nextBtn) return;

      var reduce =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function page(dir) {
        var amount = self.track.clientWidth * 0.85;
        self.track.scrollBy({
          left: dir * amount,
          behavior: reduce ? 'auto' : 'smooth'
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          page(-1);
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          page(1);
        });
      }

      this.updateArrows();
      this.track.addEventListener('scroll', function () {
        self.updateArrows();
      });
      window.addEventListener('resize', function () {
        self.updateArrows();
      });
    }

    updateArrows() {
      if (!this.prevBtn && !this.nextBtn) return;
      var track = this.track;
      // 1px slack absorbs sub-pixel rounding at the ends.
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      var scrollable = maxScroll > 1;

      if (this.prevBtn) {
        this.prevBtn.hidden = !scrollable || track.scrollLeft <= 0;
      }
      if (this.nextBtn) {
        this.nextBtn.hidden = !scrollable || track.scrollLeft >= maxScroll;
      }
    }
  }

  if (!customElements.get('eb-featured-scroller')) {
    customElements.define('eb-featured-scroller', EbFeaturedScroller);
  }
})();
